export const CHAT_UNREAD_COUNT_CHANGED_EVENT = 'chat-unread-count-changed';

export function notifyChatUnreadCountChanged(): void {
  window.dispatchEvent(new Event(CHAT_UNREAD_COUNT_CHANGED_EVENT));
}
